// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-receipt-container {
  width: 100%;
  color: #585858;
  line-height: 1.42857143;
}
.stripe-receipt-links-top {
  width: 100%;
}
.stripe-receipt-header {
  width: 100%;
}
.stripe-receipt-details {
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  margin-bottom: 2em;
}
.stripe-receipt-details .detail-columns {
  display: flex;
  width: 45%;
  justify-content: space-between;
}
.stripe-receipt-details .detail-columns .second-column {
  color: #000;
}
.stripe-receipt-paid-on {
  margin: 1.4em 0 1em;
  font-size: 1.4em;
  color: #000;
}
.stripe-receipt-body {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.stripe-receipt-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.stripe-receipt-table th {
  text-align: left;
}
.stripe-receipt-table tr:not(.stripe-receipt-totals-row):nth-child(even) {
  background: #F6F8FA;
}
.stripe-receipt-table thead tr,
.stripe-receipt-table tbody tr.stripe-receipt-table-row-first {
  border-top: #585858 solid 1px;
}
.stripe-receipt-table thead tr,
.stripe-receipt-table tbody tr.stripe-receipt-table-row-last {
  border-bottom: #585858 solid 1px;
}
.stripe-receipt-table td,
.stripe-receipt-table th {
  padding: 1em;
}
.stripe-receipt-table th:nth-child(1) {
  width: 50%;
}
.stripe-receipt-table th:nth-child(2) {
  width: 10%;
}
.stripe-receipt-table th:nth-child(3) {
  width: 20%;
}
.stripe-receipt-totals-row td:nth-last-child(1),
.stripe-receipt-totals-row td:nth-last-child(2) {
  border-top: #585858 solid 1px;
}
.stripe-receipt-totals-row td:nth-last-child(1),
.stripe-receipt-totals-row td:nth-last-child(2) {
  background: #F6F8FA;
}
.stripe-receipt-totals-row.amount-paid td:nth-last-child(1),
.stripe-receipt-totals-row.amount-paid td:nth-last-child(2) {
  color: #000;
  background-color: #DDD;
}

body.stripe-receipt-body {
  width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 2em;
}

@page {
  size: letter;
  margin: 0;
}

@media print {
  html {
    width: 21cm;
    color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  body.stripe-receipt-body {
    width: 100%;
    padding: 20mm 20mm 20mm 30mm;
  }
  .stripe-receipt-links-top {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/receipt.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;IACnB,iCAAiC;EACnC;EACA;IACE,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".stripe-receipt-container {\n  width: 100%;\n  color: #585858;\n  line-height: 1.42857143;\n}\n.stripe-receipt-links-top {\n  width: 100%;\n}\n.stripe-receipt-header {\n  width: 100%;\n}\n.stripe-receipt-details {\n  display: flex;\n  flex-flow: column;\n  align-items: flex-end;\n  margin-bottom: 2em;\n}\n.stripe-receipt-details .detail-columns {\n  display: flex;\n  width: 45%;\n  justify-content: space-between;\n}\n.stripe-receipt-details .detail-columns .second-column {\n  color: #000;\n}\n.stripe-receipt-paid-on {\n  margin: 1.4em 0 1em;\n  font-size: 1.4em;\n  color: #000;\n}\n.stripe-receipt-body {\n  font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.stripe-receipt-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.stripe-receipt-table th {\n  text-align: left;\n}\n.stripe-receipt-table tr:not(.stripe-receipt-totals-row):nth-child(even) {\n  background: #F6F8FA;\n}\n.stripe-receipt-table thead tr,\n.stripe-receipt-table tbody tr.stripe-receipt-table-row-first {\n  border-top: #585858 solid 1px;\n}\n.stripe-receipt-table thead tr,\n.stripe-receipt-table tbody tr.stripe-receipt-table-row-last {\n  border-bottom: #585858 solid 1px;\n}\n.stripe-receipt-table td,\n.stripe-receipt-table th {\n  padding: 1em;\n}\n.stripe-receipt-table th:nth-child(1) {\n  width: 50%;\n}\n.stripe-receipt-table th:nth-child(2) {\n  width: 10%;\n}\n.stripe-receipt-table th:nth-child(3) {\n  width: 20%;\n}\n.stripe-receipt-totals-row td:nth-last-child(1),\n.stripe-receipt-totals-row td:nth-last-child(2) {\n  border-top: #585858 solid 1px;\n}\n.stripe-receipt-totals-row td:nth-last-child(1),\n.stripe-receipt-totals-row td:nth-last-child(2) {\n  background: #F6F8FA;\n}\n.stripe-receipt-totals-row.amount-paid td:nth-last-child(1),\n.stripe-receipt-totals-row.amount-paid td:nth-last-child(2) {\n  color: #000;\n  background-color: #DDD;\n}\n\nbody.stripe-receipt-body {\n  width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 2em;\n}\n\n@page {\n  size: letter;\n  margin: 0;\n}\n\n@media print {\n  html {\n    width: 21cm;\n    color-adjust: exact;\n    -webkit-print-color-adjust: exact;\n  }\n  body.stripe-receipt-body {\n    width: 100%;\n    padding: 20mm 20mm 20mm 30mm;\n  }\n  .stripe-receipt-links-top {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
